module.exports = __webpack_public_path__ + "static/media/documento.633754d5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documento.pdf
// module id = 1967
// module chunks = 2